import script from "./ImportRequestAccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportRequestAccess.vue?vue&type=script&setup=true&lang=ts"

import "./ImportRequestAccess.vue?vue&type=style&index=0&id=530d23f3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530d23f3"]])

export default __exports__